export enum SearchEntityType {
  STAKEHOLDER = 'stakeholder',
  ORGANIZATION = 'organization',
  ASSIGNMENT = 'assignment',
  WIKI_PAGE = 'wiki_page',
  RELATIONSHIP = 'relationship',
  MEDIA_ASSET = 'media_asset',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface SearchQuery {
  q?: string;
  entityTypes?: SearchEntityType[];
  organizationType?: string;
  location?: string;
  role?: string;
  department?: string;
  organizationId?: string;
  stakeholderId?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
  includeHighlights?: boolean;
}

export interface SearchHighlight {
  field: string;
  fragments: string[];
}

export interface SearchResultItem {
  id: string;
  entityType: SearchEntityType;
  score: number;
  data: any;
  highlights?: SearchHighlight[];
}

export interface SearchFacet {
  field: string;
  values: { value: string; count: number }[];
}

export interface SearchResult {
  items: SearchResultItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  facets?: SearchFacet[];
  executionTime: number;
}

export interface SearchSuggestion {
  text: string;
  type: string;
  entityType: string;
  id?: string;
  count: number;
}

export interface SearchSuggestionsResponse {
  suggestions: SearchSuggestion[];
}

export interface SearchFilters {
  entityTypes: SearchEntityType[];
  organizationType?: string;
  location?: string;
  role?: string;
  department?: string;
  organizationId?: string;
  stakeholderId?: string;
}
